module.exports = __webpack_public_path__ + "static/media/README.b165bd54.md";